// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip-builder__tooltip--KkdMC"};